import './fixed_header.less';

import React, {Proptypes} from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router';
import DashboardDropdown from '../components/dashboard_dropdown/dashboard_dropdown';
import Notifications from '../components/notification/notification'
import ClickOutside from 'react-click-outside';
// import '../../client/base.js';

class DashboardFixedHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupActive: false,
      notificationsDivActive : false,
      showBubble : false
    }
    this.togglePopup = this.togglePopup.bind(this);
    this.handleBodyClick = this.handleBodyClick.bind(this);
  }

  togglePopup(e){
    e.preventDefault();
    const popupStatus = !this.state.popupActive;
    this.setState({popupActive: popupStatus,notificationsDivActive:false})
  }
  toggleNotificationPopup = (e) =>{
    e.preventDefault();
    let notificationsStatus = !this.state.notificationsDivActive
    this.setState({notificationsDivActive: notificationsStatus , popupActive : false})
  }
  handleBodyClick(e){
    if(e.target.matches('.dashboard-dropdown-elm')){
    }
    else if(e.target.className == 'notifications' || e.target.className == 'notification-content' || e.target.className == 'notification-date' || e.target.className =='notification-header' || e.target.className =='icon-notification' || e.target.className == 'icon-cross-feather' || e.target.className == 'notification-header-wrap' || e.target.className == 'notification-delete'|| e.target.className =='notification-content-wrap'){

    }
    else if(!(e.target.matches('.profile-name-elm') || e.target.matches('.icon-down-arrow-filled')) ){
      if(this.state.popupActive){
        this.setState({
          popupActive: false
        })
      }
      if(this.state.notificationsDivActive){
        this.setState({
          notificationsDivActive: false
        })
      }
    }
  }

  componentDidMount(){
    document.body.addEventListener('click', this.handleBodyClick);
    document.body.addEventListener("touchstart", this.handleBodyClick);
    document.body.addEventListener("touchend", this.handleBodyClick);
    document.body.addEventListener("touchcancel", this.handleBodyClick);
    document.body.addEventListener("touchmove", this.handleBodyClick);
  }


  componentWillUnmount(){
    document.body.removeEventListener('click', this.handleBodyClick);
    document.body.removeEventListener("touchstart", this.handleBodyClick);
    document.body.removeEventListener("touchend", this.handleBodyClick);
    document.body.removeEventListener("touchcancel", this.handleBodyClick);
    document.body.removeEventListener("touchmove", this.handleBodyClick);
  }

  render(){
    const {state, props} = this;
    let userProfileImage = '';
    let {isVerified} = this.props.user;
    if(props.user) {
      userProfileImage = props.user.imageUrl || "../../public/images/user_placeholder.svg";
    }
    const notifications = this.props.notifications;
    let showBubble = false;
    let location = this.props.location;
     (location && location.pathname) ? (location = location.pathname) : (location = null);
    if(notifications)
    {
      for(let i=0;i< notifications.length;i++)
      {
          if(notifications[i].isRead == false)
          {
            showBubble = true
            break;
          }
      }
    }
    return(
      <div className="dashboard-fixed-header-wrp">
          <div className = "dashboard-fixed-header cf">
            <div className = "dashboard-logo-wrp f-l">
              <Link to = "/dashboard"><img className = "dashboard-img-elm" src="../../public/images/landing/logo_white_saffron.png"/></Link>
            </div>
            <div className = "menu-options-wrp f-r">
              <div className = "nav-link-wrap">
                <Link to="/dashboard" className="nav-link" activeClassName="nav-selected">Dashboard</Link>
              </div>
              <div className = "nav-link-wrap">
                <Link to="/browse-shipments" className="nav-link" activeClassName="nav-selected">Browse</Link>
              </div>
              <div className = "nav-link-wrap">
                <Link to="/inbox" className="nav-link" activeClassName="nav-selected">Messages</Link>
              </div>
              {/*<div className = "nav-link-wrap">
                <Link to="/account" className="nav-link" activeClassName="nav-selected">Account</Link>
              </div>*/}
              {(location == '/dashboard' || location == '/dashboard/i-am-carrying' || location == '/dashboard/i-am-shipping' || location == '/dashboard/i-am-receiving') && <div className = "nav-link-wrap">
                <div className={showBubble ? "notification-bubble" :"hide"}></div>
                <span className="icon-notification" onClick ={this.toggleNotificationPopup}></span>
              </div>}
              <div className = "nav-link-wrap">
                <div className="img-wrap">
                  <Link to="/profile"><img className="profile-img-elm awb-btn" src={userProfileImage}/></Link>
                  {isVerified &&  <div className="profile-is-verified"></div>}
                </div>

                <div className="profile-name-wrp" onClick={this.togglePopup}>
                  <span className="profile-name-elm">{props.user.name}</span><span className="icon-down-arrow-filled"></span>
                </div>
              </div>
            </div>
          </div>
          { state.popupActive && <DashboardDropdown/> }
          { state.notificationsDivActive && <Notifications/> }
        </div>
    )
  }
}
module.exports = DashboardFixedHeader;



// WEBPACK FOOTER //
// app/header_dashboard/fixed_header.jsx